import React from 'react'

import { Box, useTokens, Typography } from '@barracuda-internal/bds-core-v2'

const EmailInfo: React.FC<{
  user: string
  headerFrom: string
  subject: string
  date: string
}> = ({ user, headerFrom, subject, date }) => {
  const tokens = useTokens()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: 'fill',
        height: 'auto',
        gap: tokens.aliasesSpaceContainerDefault,
        padding: tokens.aliasesSpaceContainerDefault,
        radius: tokens.aliasesBorderRadiusDefault,
        backgroundColor: tokens.aliasesColorBgStaticContainerNeutral,
        border: `${tokens.aliasesBorderWidthDefault} solid ${tokens.aliasesColorBorderStaticContainerSubtle}`
      }}
    >
      <Typography variant="h3" sx={{ textAlign: 'left' }}>
        {subject}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: 'fill',
          height: 'auto',
          gap: tokens.aliasesSpaceContainerDefault,
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: 'fill',
            height: 'auto',
            gap: tokens.aliasesSpaceContainerDense
          }}
        >
          <Typography variant="body1Bold" sx={{ textAlign: 'left' }}>
            From: {headerFrom}
          </Typography>
          <Typography variant="body1Bold" sx={{ textAlign: 'left' }}>
            To: {user}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: 'auto', height: 'auto' }}>
          <Typography variant="body1" sx={{ textAlign: 'left' }}>
            {date}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default EmailInfo
